

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETAPPRAISALYEARPMSSCORESTATUSBYYEAR= createAsyncThunk(
  "getAppraisalYearPmsScoreStatusByYear/getAppraisalYearPmsScoreStatusByYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAppraisalYearPmsScoreStatusByYearSlice = createSlice({
  name: "getAppraisalYearPmsScoreStatusByYearSlice",
  initialState: {
    getAppraisalYearPmsScoreStatusByYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAppraisalYearPmsScoreStatusByYear: (state) => {
        state.getAppraisalYearPmsScoreStatusByYear.loading = false
        state.getAppraisalYearPmsScoreStatusByYear.error = false
        state.getAppraisalYearPmsScoreStatusByYear.data = []
        state.getAppraisalYearPmsScoreStatusByYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETAPPRAISALYEARPMSSCORESTATUSBYYEAR.fulfilled, (state, action) => {
      state.getAppraisalYearPmsScoreStatusByYear = {
        ...state.getAppraisalYearPmsScoreStatusByYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAPPRAISALYEARPMSSCORESTATUSBYYEAR.pending, (state, action) => {
      state.getAppraisalYearPmsScoreStatusByYear = {
        ...state.getAppraisalYearPmsScoreStatusByYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAPPRAISALYEARPMSSCORESTATUSBYYEAR.rejected, (state, action) => {
      state.getAppraisalYearPmsScoreStatusByYear = {
        ...state.getAppraisalYearPmsScoreStatusByYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAppraisalYearPmsScoreStatusByYearAction = {
    GETAPPRAISALYEARPMSSCORESTATUSBYYEAR,
};

export { getAppraisalYearPmsScoreStatusByYearAction };
export default getAppraisalYearPmsScoreStatusByYearSlice.reducer;
export const {setInitialStateOfgetAppraisalYearPmsScoreStatusByYear} = getAppraisalYearPmsScoreStatusByYearSlice.actions
